import { CloseOutlined, MobileOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Styles from "./PwaBanner.styles";
import { PwaInstallGuide } from "./PwaInstallGuide";

interface Props {
  onInstall: () => void;
  onDismiss: () => void;
  isIOS?: boolean;
}

export const PwaBanner: React.FC<Props> = ({ onInstall, onDismiss, isIOS }) => {
  const { t } = useTranslation();
  const [guideOpen, setGuideOpen] = useState(false);
  const openGuide = () => setGuideOpen(true);

  return (
    <Styles.Banner>
      <Styles.Content>
        <Styles.Icon>
          <MobileOutlined />
        </Styles.Icon>
        <Styles.Text>
          <Styles.Title>{t("PwaInstallTitle")}</Styles.Title>
          <Styles.Description>
            {isIOS ? t("PwaInstallIOSDescription") : t("PwaInstallDescription")}
            {!isIOS && (
              <Styles.GuideLink onClick={openGuide}>
                {t("PwaGuideLink")}
              </Styles.GuideLink>
            )}
          </Styles.Description>
        </Styles.Text>
        <Styles.Actions>
          {/* iOS has no native prompt, so the guide is the main action there */}
          {isIOS ? (
            <Styles.InstallBtn onClick={openGuide}>
              {t("PwaGuideButton")}
            </Styles.InstallBtn>
          ) : (
            <Styles.InstallBtn onClick={onInstall}>
              {t("PwaInstallAccept")}
            </Styles.InstallBtn>
          )}
          <Styles.DismissBtn onClick={onDismiss}>
            <CloseOutlined />
          </Styles.DismissBtn>
        </Styles.Actions>
      </Styles.Content>
      <PwaInstallGuide
        open={guideOpen}
        onClose={() => setGuideOpen(false)}
        onInstall={isIOS ? undefined : onInstall}
      />
    </Styles.Banner>
  );
};
